export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';

export const MODAL_TYPE_TEAM_DETAIL = 'MODAL_TYPE_TEAM_DETAIL';
export const MODAL_TYPE_USER_DETAIL = 'MODAL_TYPE_USER_DETAIL';
export const MODAL_TYPE_RULES = 'MODAL_TYPE_RULES';
export const MODAL_TYPE_DELETE_PHOTO = 'MODAL_TYPE_DELETE_PHOTO';
export const MODAL_TYPE_DELETE_ACCOUNT = 'MODAL_TYPE_DELETE_ACCOUNT';



// WEBPACK FOOTER //
// ./src/data/constants/modal-constants.jsx